import { MessageCircle } from "lucide-react";
import { waLink, MESSAGES } from "@/data/site";
import { useLang } from "@/i18n";

export const WhatsAppFloat = ({ message }) => (
  <a
    href={waLink(message || MESSAGES.generic)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="Chat with Disign Digital on WhatsApp"
    className="fixed bottom-24 sm:bottom-6 right-4 sm:right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-105"
  >
    <MessageCircle className="h-7 w-7" fill="currentColor" />
  </a>
);

export const MobileStickyCta = () => {
  const t = useLang().t;
  return (
  <div
    data-testid="mobile-sticky-cta"
    className="fixed bottom-0 left-0 right-0 z-40 sm:hidden border-t border-[#EFEBE4] bg-[#FDFBF7]/95 backdrop-blur-xl px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
  >
    <div className="flex gap-3">
      <a
        href={waLink(MESSAGES.home)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-sticky-whatsapp"
        className="btn-whatsapp flex-1 !py-3 text-sm"
      >
        <MessageCircle className="h-4 w-4" /> {t.sticky.whatsapp}
      </a>
      <a href="#contact" data-testid="mobile-sticky-get-website" className="btn-primary flex-1 !py-3 text-sm">
        {t.sticky.getWebsite}
      </a>
    </div>
  </div>
  );
};

export default WhatsAppFloat;
